import React, { useEffect, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import UserAvatar from "../../components/UserAvatar";
import { Form } from "react-bootstrap";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import LanguageContext from "../../helper/LanguageContext";
import { callAPI } from "../../helper/apiUtils";
import { Scrollbars } from "react-custom-scrollbars";
import _ from "lodash";
import { BASE_URL, KJUUP_COLORS } from "../../helper/constants";
import { $user } from "../../helper/UserFactory";
import {
  FROM_FROROIEGN_PROFILE,
  GROUPS,
  GROUPS_BOTTOM,
  OPEN_BOTTOM_CHATS,
  OPEN_CHATS,
  OPEN_PROJECTS,
  TOGGLE_PROJECT,
  RIGHT_TOP,
  SET_OPEN_SIDE_BAR,
  TOGGLE_CHAT,
  SET_IN_ACTIVITY,
  TOGGLE_LATEST_MSG,
  TOGGLE_WORK_AREA,
  SET_DEEPLINK_DATA,
  SET_DEEPLINK_LOADING,
} from "../../store";
import { connect, useDispatch, useSelector } from "react-redux";
import { convertBranchRole } from "../../helper/convertor";
import FollowOneToOne from "./FollowOneToOne";
import { Discuss, Rings } from 'react-loader-spinner'
import "./AddOneToOneUser.css";

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return (
    <div
      className="thumb-style"
      style={{ ...style, ...thumbStyle }}
      {...props}
    />
  );
};





function AddOneToOneUser(props) {
  const { isGerm, strings } = React.useContext(LanguageContext);
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [userList, setUsersList] = useState([]);
  const [isFollow, setIsFollow] = useState(false);
  const [action, setAction] = useState("");
  const [page, setPage] = useState(1)
  const [isGettingImages, setIsGettingImages] = useState(false)
  const [isDataOver, setIsDataOver] = useState(false)
  const [isSearch, setIsSearch] = useState(false)
  const [searchedUsers, setSearchedUsers] = useState([])
  const [viewLoader, setViewLoader] = useState(false)
  const [companyGroups, setCompanyGroups] = useState([])
  const [openCompanies, setOpenCompanies] = useState(new Set())
  const companyGroupsInitialized = React.useRef(false)
  let user = useSelector((state) => state.user);
  const dispatch = useDispatch()
  const getUsers = async (page, keyword) => {
    const { data } = await callAPI(`/user/allUsersSearch?limit=50&page=${page}&query=${keyword}&forChat=1`, {}, "GET");
    await CreateList(data.data.users);
    if (data.data.companyUsers && page === 1) {
      const seen = new Set();
      const deduped = data.data.companyUsers
        .map((cg) => ({
          ...cg,
          users: (cg.users || []).filter((u) => {
            if (!u?.id || seen.has(u.id)) return false;
            seen.add(u.id);
            return true;
          }),
        }))
        .filter((cg) => cg.users.length > 0);
      setCompanyGroups(deduped);
      if (!companyGroupsInitialized.current) {
        companyGroupsInitialized.current = true;
        if (deduped.length === 1) {
          setOpenCompanies(new Set([deduped[0].companyId]));
        }
      }
    }
  };

  const searchUsers = async (page, keyword) => {
    setIsSearch(true)
    const { data } = await callAPI(`/user/allUsersSearch?limit=50&page=${page}&query=${keyword}&forChat=1`, {}, "GET");
    setSearchedUsers(data.data.users);
    if (data.data.companyUsers) {
      const seen = new Set();
      const deduped = data.data.companyUsers
        .map((cg) => ({
          ...cg,
          users: (cg.users || []).filter((u) => {
            if (!u?.id || seen.has(u.id)) return false;
            seen.add(u.id);
            return true;
          }),
        }))
        .filter((cg) => cg.users.length > 0);
      setCompanyGroups(deduped);
    }
    setIsSearch(false)
  };

  const CreateList = async (US) => {
    if (userList.length == 0) {
      setUsers(US);
      setUsersList(US);
    }
    else {
      let tmp = [...userList]
      tmp = [...tmp, ...US]
      setUsers(tmp)
      setUsersList(tmp)
    }
  };

  useEffect(() => {
    getUsers(1, '');
  }, []);

  const filterUsers = async (text) => {
    setSearch(text);
    text = text?.toLowerCase().trim()
    searchUsers(1, text)
  };


  const _onFollowClick = async (followingId) => {
    callAPI(`/user/${followingId}/follow?id=${followingId}`, {}, "GET");
  }

  const addProjectUser = async (u) => {
    setViewLoader(true)
    const user = $user.get();
    const { data } = await callAPI(`/group`, {}, "POST", {
      groupType: "user",
      isOneToOne: true,
      users: [user?.id, u.id],
    });
    if (!u.isFollowing) {
      _onFollowClick(u.id)
    }
    setViewLoader(false)
    // props.afterAddUser(u);
    props.hide();
    dispatch({ type: SET_DEEPLINK_LOADING, loading: true, isInternal: false })
    dispatch({ type: TOGGLE_CHAT, payload: false })
    dispatch({ type: SET_DEEPLINK_DATA, payload: { chatGroupId: data.chat.id } });
    dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    dispatch({ type: TOGGLE_PROJECT, payload: false });
    dispatch({ type: OPEN_PROJECTS, openProjects: [] });
    dispatch({ type: OPEN_CHATS, openChats: [] });
    dispatch({ type: SET_IN_ACTIVITY, payload: false });
    dispatch({ type: TOGGLE_WORK_AREA, toggleWorkArea: true });
    dispatch({ type: GROUPS, groups: [] })
    // Use requestAnimationFrame for immediate execution instead of setTimeout
    requestAnimationFrame(() => {
      dispatch({ type: FROM_FROROIEGN_PROFILE, payload: 'pageLoad' });
      dispatch({ type: SET_OPEN_SIDE_BAR, payload: 'chat1' });
      dispatch({ type: RIGHT_TOP, rightTop: 'chat1' });
    });
    // const group = await props.groups.find((cht) => cht.id === data.chat.id);
    // if (group) {
    //   const chk = await props.openChats.find((g) => g.id === data.chat.id);
    //   if (chk) {
    //     await props.updateOpenChats(
    //       _.uniqBy([...props.openChats, chk], "id")
    //     );
    //   } else {
    //     await props.updateOpenChats([...props.openChats, group]);
    //     const updateGroup = await props.groups.map((g) => {
    //       if (g.id === group.id) {
    //         return { ...g, isOpenedTop: true };
    //       } else {
    //         return { ...g, isOpenedTop: false }
    //       }
    //     });
    //     props.updateGroups(updateGroup);
    //   }
    // }

  };


  const handleScroll = (e) => {
    const bottom = parseInt(e.target.scrollHeight - e.target.scrollTop) <= parseInt(e.target.clientHeight);
    if (bottom) {
      console.log('end')
      if (!isGettingImages && !isDataOver) {
        let p = page + 1
        setPage(p)
        getUsers(p, '')
      }
    }
  }

  return (
    <React.Fragment>
      <div className="one-to add-one-to-one-user">
        {viewLoader && (
          <div className="website_loader">
            <div className="loader" />
          </div>
        )}
        <div className="main_heading">
          <a onClick={(e) => props.hide()} className="main_heading pointer">
            <span className="material-symbols-outlined material-arrow-left">
              keyboard_arrow_left
            </span>
            {strings.cancel}
          </a>
        </div>
        <div className="invite add_one_to_user">
          <div className="admin_right">
            <div className="search_div">
              <div className="search">
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Control
                    autocomplete="off"
                    value={search}
                    type="text"
                    placeholder={strings.search}
                    onChange={(e) => filterUsers(e.target.value)}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </div>
        {
          isSearch ?
            <div className="add-one-to-one-user__loading">
              <div className="kj-flex-1" />
              <div>
                <Rings
                  height="100"
                  width="100"
                  color={KJUUP_COLORS.base_color}
                  radius="6"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="rings-loading"
                />
              </div>
              <div className="kj-flex-1" />
            </div>
            :
            <></>
        }
        {!search ?
          <div onScroll={handleScroll} className="scroll add-one-to-one-user__list">
            {companyGroups.length > 0 && (
              <div className="mb-2">
                {companyGroups.map((cg) => {
                  const isOpen = openCompanies.has(cg.companyId);
                  return (
                    <div key={cg.companyId} className="mb-1">
                      <div
                        onClick={() => {
                          setOpenCompanies((prev) => {
                            const next = new Set(prev);
                            if (next.has(cg.companyId)) next.delete(cg.companyId);
                            else next.add(cg.companyId);
                            return next;
                          });
                        }}
                        className="add-one-to-one-user__company-head"
                      >
                        <span className="add-one-to-one-user__company-name">
                          {cg.companyName} ({cg.users.length})
                        </span>
                        <span className="material-symbols-outlined add-one-to-one-user__chevron">
                          {isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                        </span>
                      </div>
                      {isOpen && cg.users.length > 0 && (
                        <div className="add-one-to-one-user__company-users">
                          {_.sortBy(cg.users, [(u) => u?.lastName?.toLowerCase()]).map((u) => (
                            u.id !== user.id ?
                              <div key={`company-${cg.companyId}-${u.id}`} className="admin-contact add-one-to-one-user__contact--company">
                                <div className="row m-0">
                                  <div className="col-md-12 p-0 pointer" onClick={() => addProjectUser(u)}>
                                    <div className="admin-control add-one-to-one-user__control">
                                      <UserAvatar
                                        width={30}
                                        height={30}
                                        className="news_profile"
                                        src={u.img ? BASE_URL + u.img : process.env.PUBLIC_URL + "/assets/img/head.svg"}
                                        alt="User avatar"
                                        fallbackSrc={process.env.PUBLIC_URL + "/assets/img/head.svg"}
                                      />
                                      <h4>{u.name}</h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              : <React.Fragment key={`company-${cg.companyId}-${u.id}`} />
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
                <div className="add-one-to-one-user__divider" />
              </div>
            )}
            {users && (() => {
              const companyUserIds = new Set(
                companyGroups.flatMap((cg) => (cg.users || []).map((cu) => cu.id))
              );
              return users.filter((u) => !companyUserIds.has(u.id)).map((u, i) => (
                u.id !== user.id ?
                  <div key={u.id || i} className="admin-contact add-one-to-one-user__contact">
                    <div className="row m-0">
                      <div
                        className="col-md-12 p-0 pointer"
                        onClick={(e) => addProjectUser(u)}
                      >
                        <div className="admin-control add-one-to-one-user__control">
                          <UserAvatar
                            width={30}
                            height={30}
                            className="news_profile"
                            src={
                              u.img
                                ? BASE_URL + u.img
                                : process.env.PUBLIC_URL +
                                "/assets/img/head.svg"
                            }
                            alt="User avatar"
                            fallbackSrc={process.env.PUBLIC_URL + "/assets/img/head.svg"}
                            isKjuup={u.isKjuup || u.companies?.some(c => c.isKjuup)}
                          />
                          <h4>
                            {u.name}
                            <span>
                              {convertBranchRole(u.details, isGerm) ||
                                u.details}
                            </span>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  :
                  <React.Fragment key={`self-${u.id || i}`} />
              ));
            })()}
          </div>
          :
          !isSearch ?
            <div className="scroll add-one-to-one-user__list add-one-to-one-user__list--search">
              {companyGroups.length > 0 && (() => {
                const filtered = companyGroups.map((cg) => ({
                  ...cg,
                  users: cg.users.filter((u) => {
                    const lower = search.toLowerCase().trim();
                    const parts = lower.split(/\s+/);
                    if (parts.length > 1) {
                      const first = parts[0], rest = parts.slice(1).join(" ");
                      return (
                        (u.firstName || '').toLowerCase().startsWith(first) && (u.lastName || '').toLowerCase().startsWith(rest)
                      ) || (
                        (u.lastName || '').toLowerCase().startsWith(first) && (u.firstName || '').toLowerCase().startsWith(rest)
                      );
                    }
                    return (u.firstName || '').toLowerCase().startsWith(lower) || (u.lastName || '').toLowerCase().startsWith(lower);
                  }),
                })).filter((cg) => cg.users.length > 0);
                if (!filtered.length) return null;
                return (
                  <div className="mb-2">
                    {filtered.map((cg) => {
                      const isOpen = openCompanies.has(cg.companyId);
                      return (
                        <div key={cg.companyId} className="mb-1">
                          <div
                            onClick={() => {
                              setOpenCompanies((prev) => {
                                const next = new Set(prev);
                                if (next.has(cg.companyId)) next.delete(cg.companyId);
                                else next.add(cg.companyId);
                                return next;
                              });
                            }}
                            className="add-one-to-one-user__company-head"
                          >
                            <span className="add-one-to-one-user__company-name">
                              {cg.companyName} ({cg.users.length})
                            </span>
                            <span className="material-symbols-outlined add-one-to-one-user__chevron">
                              {isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                            </span>
                          </div>
                          {isOpen && cg.users.length > 0 && (
                            <div style={{
                              margin: "0 4px", borderLeft: "2px solid rgba(var(--kjuup-accent-rgb),0.3)",
                              borderRadius: "0 0 0 6px", backgroundColor: "rgba(var(--kjuup-accent-rgb),0.03)",
                            }}>
                              {_.sortBy(cg.users, [(u) => u?.lastName?.toLowerCase()]).map((u) => (
                                u.id !== user.id ?
                                  <div key={`search-company-${cg.companyId}-${u.id}`} className="admin-contact add-one-to-one-user__contact--company">
                                    <div className="row m-0">
                                      <div className="col-md-12 p-0 pointer" onClick={() => addProjectUser(u)}>
                                        <div className="admin-control add-one-to-one-user__control">
                                          <UserAvatar
                                            width={30} height={30} className="news_profile"
                                            src={u.img ? BASE_URL + u.img : process.env.PUBLIC_URL + "/assets/img/head.svg"}
                                            alt="User avatar"
                                            fallbackSrc={process.env.PUBLIC_URL + "/assets/img/head.svg"}
                                          />
                                          <h4>{u.name}</h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  : <React.Fragment key={`search-company-${cg.companyId}-${u.id}`} />
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                    <div className="add-one-to-one-user__divider" />
                  </div>
                );
              })()}
              {searchedUsers && (() => {
                const companyUserIds = new Set(
                  companyGroups.flatMap((cg) => (cg.users || []).map((cu) => cu.id))
                );
                return searchedUsers.filter((u) => !companyUserIds.has(u.id)).map((u, i) => (
                  u.id !== user.id ?
                    <div key={u.id || i} className="admin-contact add-one-to-one-user__contact">
                      <div className="row m-0">
                        <div
                          className="col-md-12 p-0 pointer"
                          onClick={(e) => addProjectUser(u)}
                        >
                          <div className="admin-control add-one-to-one-user__control">
                            <UserAvatar
                              width={30}
                              height={30}
                              className="news_profile"
                              src={
                                u.img
                                  ? BASE_URL + u.img
                                  : process.env.PUBLIC_URL +
                                  "/assets/img/head.svg"
                              }
                              alt="User avatar"
                              fallbackSrc={process.env.PUBLIC_URL + "/assets/img/head.svg"}
                            />
                            <h4>
                              {u.name}
                              <span>
                                {convertBranchRole(u.details, isGerm) ||
                                  u.details}
                              </span>
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    :
                    <React.Fragment key={`search-self-${u.id || i}`} />
                ));
              })()}
            </div>
            :
            <></>
        }
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  const { groups, groupsBottom, openChats, openBottomChats } = state;
  return {
    groups: groups,
    groupsBottom: groupsBottom,
    openChats: openChats,
    openBottomChats: openBottomChats,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateGroups: (groups) => dispatch({ type: GROUPS, groups: groups }),
    updateOpenChats: (chats) =>
      dispatch({ type: OPEN_CHATS, openChats: chats }),
    updateGroupsBottom: (groups) =>
      dispatch({ type: GROUPS_BOTTOM, groupsBottom: groups }),
    updateOpenBottomChats: (chats) =>
      dispatch({ type: OPEN_BOTTOM_CHATS, openBottomChats: chats }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AddOneToOneUser));
